<template>
  <div id="paymentDetails">
    <v-col cols="12" class="mb-0 mt-0 pb-0 pt-0">
      <div class="text-h5">Room Guest Information</div>
    </v-col>
    <guest-info></guest-info>
    <v-form ref="formPayment" @submit.prevent lazy-validation v-model="isValid">
      <v-alert :value="alert" color="pink" dark border="top" type="error" transition="scale-transition">
        {{ errorMessage }}
      </v-alert>
      <v-container>
        <v-col cols="12"  class="mb-0 mt-0 pb-0 pt-0">
          <div class="text-h5">Billing Details</div>
        </v-col>
        <!-- <v-col cols="12" class="mb-0 mt-0 pb-0 pt-0">
          <div class="text-subtitle-2">Guest Details</div>
        </v-col> -->
        <div v-if="$vuetify.breakpoint.xsOnly">
          <v-row>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.firstName" type="text" required :rules="nameRules"
                label="First Name" dense solo></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.lastName" required :rules="lastNameRules" label="Last Name"
                dense solo>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.email" required :rules="emailRules" label="Email" dense solo>
              </v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.mobileNumber" required :rules="phoneRules" label="Phone" dense
                solo>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-autocomplete v-model="$store.state.guest.countryCode" required :rules="countryRules" :items="countries"
                item-text="name" item-value="code" single-line label="Select Country" dense solo></v-autocomplete>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-select v-model="$store.state.guest.time" :items="arrivalTimes" item-text="text" item-value="value"
                label="Select Time" dense solo></v-select>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.firstName" type="text" required :rules="nameRules"
                label="First Name" dense solo></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.lastName" required :rules="lastNameRules" label="Last Name"
                dense solo>
              </v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.email" required :rules="emailRules" label="Email" dense solo>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-text-field v-model="$store.state.guest.mobileNumber" required :rules="phoneRules" label="Phone" dense
                solo>
              </v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-autocomplete v-model="$store.state.guest.countryCode" required :rules="countryRules" :items="countries"
                item-text="name" item-value="code" single-line label="Select Country" dense solo></v-autocomplete>
            </v-col>
            <v-col lg="4" md="4" sm="6" xs="12">
              <v-select v-model="$store.state.guest.time" :items="arrivalTimes" item-text="text" item-value="value"
                label="Select Time" dense solo></v-select>
            </v-col>
          </v-row>
        </div>
        <v-textarea v-model="$store.state.guest.specialRequests" solo name="input-7-4" label="Special Request">
        </v-textarea>

        <v-col cols="12" class="d-block mb-0 mt-0 pb-0 pt-0">
          <div class="text-subtitle-2">Payment Method</div>
        </v-col>
        <v-divider></v-divider>
        <!-- <v-row no-gutters>
        <v-col md="6" offset-md="2">
          <div class="text-subtitle-2">Debit/Credit Card</div>
        </v-col>
      </v-row> -->
        <v-radio-group v-if="!isInternal" :rules="paymentModeRules" v-model="$store.state.guest.paymentMode">
          <template v-for="(option, ioption) in GetPaymentModes()">
            <!-- <div v-if="ioption == 1" class="text-subtitle-2 mt-2">Debit/Credit Card</div> -->
            <v-radio :label="getPaymentModename(option)" :value="option.type">


              <!-- <template  v-slot:label>
             
            </template> -->
              <template v-if="option.paymentCategory !== 'BankTransfer' && option.paymentCategory !== 'Paypal'"
                v-slot:label>
                <!-- <v-img v-if="option.type === 'xendit'" max-width="80" height="50" src="/img/xendit-logo-vector.svg"></v-img>
              <v-img v-if="option.type === 'ipay88'" max-width="80" height="70" src="/img/ipay88-logo.png"></v-img>
              <v-img v-if="option.type === 'paypal'" max-width="80" height="50" src="/img/paypal-logo.png"></v-img> -->
                <span class="mr-2">Debit/Credit Card</span>
              </template>
              <template v-if="option.paymentCategory === 'Paypal'" v-slot:label>
                <!-- <v-img v-if="option.type === 'xendit'" max-width="80" height="50" src="/img/xendit-logo-vector.svg"></v-img>
              <v-img v-if="option.type === 'ipay88'" max-width="80" height="70" src="/img/ipay88-logo.png"></v-img>
              <v-img v-if="option.type === 'paypal'" max-width="80" height="50" src="/img/paypal-logo.png"></v-img> -->
                <v-img v-if="option.type === 'paypal'" max-width="80" height="50" src="/img/paypal-logo.png"></v-img>
              </template>
            </v-radio>


            <template v-if="option.type === 'BankTransfer'">
              <v-col cols="3" class="mt-0 pt-0" v-show="$store.state.guest.paymentMode === 'BankTransfer'">
                <div class="text-subtitle-2 d-inline">Bank Account</div>
                <div class="text-body-2 d-inline">
                  <pre v-html="bankAccount"></pre>
                </div>
              </v-col>
            </template>

          </template>

          <!-- <v-radio label="Bank Transfer" value="2"></v-radio>
        <v-radio label="Debit/Credit Card" value="3"></v-radio> -->
        </v-radio-group>

        <!-- <v-radio-group v-if="isInternal" :rules="paymentModeRules" v-model="$store.state.guest.paymentMode" row>
        <v-radio label="Payment Pending" value="PaymentPending"></v-radio>
      </v-radio-group> -->

        <!-- <v-col lg="4" md="4" sm="6" xs="12">
        <v-select label="Select Payment Method" dense solo></v-select>
      </v-col> -->
        <!-- <v-row v-if="paymentMode === '2'">
        <v-col v-for="(payment, ipayment) in paymentGatewayList" :key="ipayment + 'payment-option'">
          <v-img width="200" height="60" @click="showPayment(payment)" :src="payment.urlImage"></v-img>
        </v-col>
      </v-row> -->

        <!-- <v-col cols="12" v-if="$store.state.guest.paymentMode === 'BankTransfer'">
        <div class="text-subtitle-2 d-inline">Bank Account</div>
        <div class="text-body-2 d-inline">
          <pre v-html="bankAccount"></pre>
        </div>
      </v-col> -->
        <v-col cols="12">
          <div class="text-body-2 d-inline">Total Payment:</div>
          <div class="text-body-1 d-inline font-weight-black">{{ GetGrandBookingSummary().displayDepositAmount }}</div>
        </v-col>
        <v-divider></v-divider>
        <v-col cols="12" class="mt-2">
          <terms-and-condition @acceptTerm="eventAcceptTerm">
            <v-checkbox :rules="termsAndConditionRules" v-model="isAccept" hide-details class="shrink mr-2 mt-0">
            </v-checkbox>
          </terms-and-condition>
        </v-col>
        <v-col class="ml-0 pl-0 mt-2" cols="12">
          <v-btn @click="bookNow" :loading="loading" :disabled="!isValid" type="submit" depressed color="success"> Pay
            Now
          </v-btn>
          <v-btn depressed color="primary" class="ml-2" @click="onAddMoreRoom" href="#roomSelectionTab">
            Add Package
          </v-btn>
          <!-- <v-btn type="submit" depressed color="success"> Book Now </v-btn> -->
        </v-col>
      </v-container>
      <!-- <v-dialog v-model="dialog" persistent fullscreen>
      <xendit v-if="selectedPaymentGateway === 'xendit'"></xendit>
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-dialog> -->
    </v-form>
  </div>

</template>

<script>
import TermsAndCondition from "../Booking/TermsAndCondition.vue";
import Xendit from "../PaymentGateway/Xendit.vue";
import GuestInfo from "../Booking/BookingDetail.vue";
import moment from 'moment';
import { mapGetters } from "vuex";


export default {
  components: {
    TermsAndCondition,
    Xendit,
    GuestInfo
  },
  data() {
    return {
      paymentGatewayList: [
        {
          urlImage: '/img/xendit-logo-vector.svg',
          isShow: false,
          code: 'xendit'
        },
        {
          urlImage: '/img/ipay88.svg',
          isShow: false,
          code: 'ipay88'
        },
        {
          urlImage: 'https://www.vectorlogo.zone/logos/paypal/paypal-ar21.svg',
          isShow: false,
          code: 'paypal'
        },
      ],
      alert: false,
      isAccept: false,
      paymentMode: null,
      dialog: false,
      selectedPaymentGateway: '',
      isValid: false,
      errorMessage: '',
      loading: false,
      nameRules: [
        v => !!v || 'First Name is required',],
      lastNameRules: [
        v => !!v || 'Last Name is required',],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneRules: [
        v => !!v || 'Phone Number is required',],
      countryRules: [
        v => !!v || 'Country is required',],
      termsAndConditionRules: [
        v => !!v || 'You must agreed to the terms and conditions'],
      paymentModeRules: [
        v => !!v || 'Choose Payment'],

    }
  },
  mounted: function () {
    this.$refs.formPayment.validate();
    window.scroll(0, 0);

  },
  methods: {
    eventAcceptTerm: function (data) {
      if (data) {
        this.isAccept = true;
      } else {
        this.isAccept = false;
      }
    },
    bookNow: function () {

      if (!this.isValid)
        return

      this.loading = true;

      this.$store.dispatch('bookNow').then((data) => {
        // this.$store.dispatch('createBooking').then(() => {
        //   this.$store.dispatch('setActiveScreen', 'bookedDetail');
        // });
        this.showPayment(data);

      }).catch((error) => {
        console.log(error);
        this.errorMessage = error;
        this.alert = true;
        this.isValid = false;
      });
    },
    showPayment: function (data) {
      let paymentMode = this.$store.state.guest.paymentMode;
      let internal = this.isInternal ? 'internal=1' : '';

      // paymentMode = 'xendit';
      // FOR XENDIT
      if (paymentMode === 'xenditucs') {
        let tbid = `tbid=${data.orderCode}`;
        let rsidlist = `rsidlist=${0}`;
        let url = 'https://ucsv2.ultronpms.com/#/CreditCardPayment?';
        let ccode = `ccode=${this.GetPropertyInformation().propertyCurrency.code}`;
        let ppid = `ppid=${this.GetPropertyCode()}`;
        let ptype = 'ptype=5';
        let pgttype = 'pgttype=1';
        let amnt = `amnt=${this.GetGrandBookingSummary().depositAmount}`;
        let spa = `spa=false`;


        let hostUrl = window.origin;
        // let hostUrl = 'http://localhost:8080';
        let successUrl = `successURL=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?orderCode=${data.orderCode}&${internal}`;

        const paymentUrl = `${url}${tbid}&${rsidlist}&${ccode}&${ppid}&${ptype}&${pgttype}&${amnt}&${spa}&${successUrl}`;
        window.location = paymentUrl;
      }
      else if (paymentMode === 'xendit') {
        let tbid = `refNo=${data.orderCode}`;
        let url = 'https://payment.ultronpms.com/Xendit?';
        // url = 'https://localhost:44372/Xendit?';
        let ccode = `currency=${this.GetPropertyInformation().propertyCurrency.code}`;
        // let ccode = `currency=IDR`;
        let ppid = `guid=${this.GetPropertyCode()}`;
        let amnt = `amnt=${this.GetGrandBookingSummary().depositAmount.toFixed(2)}`;
        // let amnt = `amnt=35000`;
        let givenName = `givenName=${this.$store.state.guest.firstName}`;
        let surname = `surname=${this.$store.state.guest.lastName}`;
        let userEmail = `email=${this.$store.state.guest.email}`;
        let userContact = `mobile=${this.$store.state.guest.mobileNumber}`;

        let hostUrl = window.origin;
        // let hostUrl = 'http://localhost:8080';
        let successUrl = `successUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?orderCode=${data.orderCode}`;
        let errorUrl = `errorUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/PaymentFailed/${data.orderCode}`;
        const paymentUrl = `${url}${tbid}&${ccode}&${ppid}&${amnt}&${givenName}&${surname}&${userContact}&&${userEmail}&${successUrl}&${errorUrl}`;
        window.location = paymentUrl;
      }
      else if (paymentMode === 'paypal') {
        let tbid = `refNo=${data.orderCode}`;
        let url = 'https://payment.ultronpms.com/Paypal?';
        // url = 'https://localhost:44372/Paypal?';
        let ccode = `currency=${this.GetPropertyInformation().propertyCurrency.code}`;
        //let ccode = `currency=AUD`;
        let ppid = `guid=${this.GetPropertyCode()}`;
        let amnt = `amnt=${this.GetGrandBookingSummary().depositAmount.toFixed(2)}`;
        let givenName = `givenName=${this.$store.state.guest.firstName}`;
        let surname = `surname=${this.$store.state.guest.lastName}`;
        let userEmail = `email=${this.$store.state.guest.email}`;
        let userContact = `mobile=${this.$store.state.guest.mobileNumber}`;
        let itemName = `itemName=`;
        let itemDescription = `itemDescription=`;

        let hostUrl = window.origin;
        // let hostUrl = 'http://localhost:8080';
        let successUrl = `successUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?orderCode=${data.orderCode}#bookingConfirmationSection`;
        let errorUrl = `errorUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/PaymentFailed/${data.orderCode}`;
        const paymentUrl = `${url}${tbid}&${ccode}&${ppid}&${amnt}&${givenName}&${surname}&${userContact}&${itemName}&${itemDescription}&${userEmail}&${successUrl}&${errorUrl}`;
        window.location = paymentUrl;
      }
      else if (paymentMode === 'BankTransfer' || paymentMode === 'PaymentPending') {
        this.$store.dispatch('clearRoomReserves');
        this.$router.push(`/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?${internal}#bookingConfirmationSection`);
        this.$forceUpdate();
        // location.reload();
      }
      else if (paymentMode === 'ipay88') {
        let tbid = `refNo=${data.orderCode}`;
        let url = 'https://payment.ultronpms.com/ProcessPayment?';
        let ccode = `currency=${this.GetPropertyInformation().propertyCurrency.code}`;
        let ppid = `guid=${this.GetPropertyCode()}`;
        let amnt = `amnt=${this.GetGrandBookingSummary().depositAmount.toFixed(2)}`;
        let userName = `userName=${this.$store.state.guest.firstName} ${this.$store.state.guest.lastName}`;
        let userEmail = `userEmail=${this.$store.state.guest.email}`;
        let userContact = `userContact=${this.$store.state.guest.mobileNumber}`;

        let hostUrl = window.origin;
        // let hostUrl = 'http://localhost:8080';
        let successUrl = `successUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?orderCode=${data.orderCode}`;
        let errorUrl = `errorUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/PaymentFailed/${data.orderCode}`;
        const paymentUrl = `${url}${tbid}&${ccode}&${ppid}&${amnt}&${userName}&${userContact}&&${userEmail}&${successUrl}&${errorUrl}`;
        window.location = paymentUrl;
      }else if (paymentMode === 'reddot') {
        let tbid = `refNo=${data.orderCode}`;
        let url = 'https://payment.ultronpms.com/RedDot?';
        // url = 'https://localhost:44372/Xendit?';
        let ccode = `currency=${this.GetPropertyInformation().propertyCurrency.code}`;
        // let ccode = `currency=IDR`;
        let ppid = `guid=${this.GetPropertyCode()}`;
        let amnt = `amnt=${this.GetGrandBookingSummary().depositAmount.toFixed(2)}`;
        // let amnt = `amnt=35000`;
        let givenName = `givenName=${this.$store.state.guest.firstName}`;
        let surname = `surname=${this.$store.state.guest.lastName}`;
        let userEmail = `email=${this.$store.state.guest.email}`;
        let userContact = `mobile=${this.$store.state.guest.mobileNumber}`;

        let hostUrl = window.origin;
        // let hostUrl = 'http://localhost:8080';
        let successUrl = `successUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/Confirmation/${data.orderCode}?orderCode=${data.orderCode}`;
        let errorUrl = `errorUrl=${hostUrl}/Booking/webreservation/${this.GetPropertyCode()}/PaymentFailed/${data.orderCode}`;
        const paymentUrl = `${url}${tbid}&${ccode}&${ppid}&${amnt}&${givenName}&${surname}&${userContact}&&${userEmail}&${successUrl}&${errorUrl}`;
        window.location = paymentUrl;
      }

    },
    getPaymentModename: function (data) {
      if (data.type === 'BankTransfer') {
        return 'Bank Transfer'
      } else {
        return 'Debit/Credit Card'
      }

    },
    onAddMoreRoom: function () {
      this.$store.dispatch('setActiveScreen', 'room');
    },
    makeId: function (length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    }
  },
  computed: {
    ...mapGetters(['GetGrandBookingSummary', 'GetPropertyInformation', 'GetPropertyCode', 'GetCountries', 'GetPaymentModes',]),
    countries: function () {
      return this.GetCountries();
    },
    arrivalTimes: function () {

      let mins = 0;
      const temp = moment(`2022-01-01 00:00`);
      let list = [];
      for (let count = 0; count <= 95; count++) {
        let ed = moment(`2022-01-01 00:00`).add(mins, 'm');
        list.push({ text: ed.format("HH:mm"), value: ed.format("HH:mm") });
        mins += 15;
      }

      return list;
    },
    isInternal: function () {
      let internal = this.$route.query.internal;

      if (internal === undefined)
        return false;

      if (internal === '1' || internal === 1)
        return true;

      return false;

    },
    bankAccount: function () {
      let bank = this.GetPropertyInformation().bePaymentSettings.find(x => x.type === 'BankTransfer');

      if (!bank) {
        return '';
      }

      return bank.bankAccount;

    }
  }

};
</script>